import createModel, {
  arbitraryKeys,
  Optional,
} from "@/__main__/data-model.mjs";

const apiModelValidation = createModel({
  [arbitraryKeys]: {
    [arbitraryKeys]: {
      [arbitraryKeys]: {
        name: String,
        description: Optional(String),
        id: Optional(Number),
        icon: Optional(String),
        key: Optional(String),
        type: Optional(String),
        champion: Optional(String),
      },
    },
  },
});

function transform(data) {
  return apiModelValidation(data);
}

export default transform;
